import {
  FontSelect as baseFontSelect,
  FontColor as baseFontColor,
  FontStyleSelect as baseFontStyleSelect,
  FontSize as baseFontSize,
  VerticalAlignment as baseVerticalAlignment,
  HorizontalAlignment as baseHorizontalAlignment,
  BackgroundColor as defaultBackgroundColorConfig,
} from 'apps/studio/components/settings/fields/Base/design'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

import { TextIcon } from '@gocanvas/gcds/icons'

const updateType = 'layoutStyles'

const FontSelect = {
  ...baseFontSelect,
  updateType,
}

const FontColor = {
  ...baseFontColor,
  updateType,
}

const FontStyleSelect = {
  ...baseFontStyleSelect,
  updateType,
}

const FontSize = {
  ...baseFontSize,
  updateType,
}

export const VerticalAlignment = {
  ...baseVerticalAlignment,
  updateType,
}

export const HorizontalAlignment = {
  ...baseHorizontalAlignment,
  updateType,
}

export const BackgroundColor = {
  ...defaultBackgroundColorConfig,
  updateType,
}

export const typographySettings = [
  SettingsLabel('Font'),
  FontSelect,
  FontSize,
  FontStyleSelect,
  FontColor,
  SettingsLabel('Alignment'),
  HorizontalAlignment,
  VerticalAlignment,
]

export const DESIGN_SETTINGS_PANEL = 'Typography'

export const DesignSettingsPanel = {
  label: DESIGN_SETTINGS_PANEL,
  icon: TextIcon,
  settings: typographySettings,
}
